import { render, staticRenderFns } from "./order_form.vue?vue&type=template&id=5aff6b7d&scoped=true&lang=pug"
import script from "./order_form.vue?vue&type=script&lang=js"
export * from "./order_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aff6b7d",
  null
  
)

export default component.exports